import { connect } from 'react-redux'
import MilitaryRecord from './MilitaryRecord.jsx'
import {
    getCollaborativeIndexationCreationFields,
    getMilitaryRecordRegistries,
    isCollaborativeIndexationCreationInvalidField,
} from '../../../../../../../redux/collaborativeIndexations/selectors'
import { updateCollaborativeIndexationFieldValue } from '../../../../../../../redux/collaborativeIndexations/actions'

const mapDispatchToProps = (dispatch, getState) => ({
    updateFieldValue: (field, value) => dispatch(updateCollaborativeIndexationFieldValue(field, value)),
})

const mapStateToProps = state => ({
    fields: getCollaborativeIndexationCreationFields(state),
    militaryRecordRegistries: getMilitaryRecordRegistries(state),
    isInvalidField: (field) => isCollaborativeIndexationCreationInvalidField(state, field),
})

export const MilitaryRecordContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(MilitaryRecord)
